var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"height":_vm.height*0.9,"headers":_vm.tableHeaders,"items":_vm.tableRows,"items-per-page":_vm.nRows,"item-key":"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }